import { DefaultToastContainer } from 'react-toast-notifications';

export default function ToastContainer(props) {
  return <DefaultToastContainer {...props} style={{ zIndex: 1400 }} />;
}
